skrilla.directive('entityLink', function ($state) {
  return {
    restrict: 'E',
    templateUrl: 'directives/entityLink/entityLink.html',
    scope: {
      reference: "=",
      id: "=",
      type: "=",
      label: "="

    },
    link: link
  };


  function getStateName(entityType) {
    //Matches the createState config on config.js
    switch (entityType) {
      case "USER":
        return "userDetails"
      case "WITHDRAWAL":
        return "withdrawalDetails"
      case "PROMOTION_CLAIM":
        return "promotionClaimDetails"
      case "BETTING_MARKET_EVENT":
        return "bettingMarkets"
      case "BETTING_MARKET":
        return "bettingMarketDetails"
      case "BET":
        return "betDetails"
      case "BETS":
        return "bets"
      case "SKRILL_DEPOSIT":
      case "DEPOSIT":
        return "depositDetails"
      case "PICKEMS_CONTEST":
        return "pickemsContestDetails"
      case "FRANCHISE":
        return "franchiseDetails"
      case "SEASON":
        return "seasonDetails"
      case "TOURNAMENT":
        return "tournamentDetails"
      case "PLAYER":
        return "playerDetails"
      case "MATCH":
        return "matchDetails"
      case "MANUAL_TRANSACTION":
        return "manualTransactions"
    }
  }

  function getIdName(entityType) {
    //Matches the createState config on config.js
    switch (entityType) {
      case "BETTING_MARKET_EVENT":
        return "eventId"
      case "BETS":
        return "eventIds"
    }
    return "id"
  }

  function link(scope) {
    let setUrl = function (type, id) {
      const stateName = getStateName(type);
      const data = {}
      data[getIdName(type)] = id
      scope.url = $state.href(stateName, data);
      scope.text = scope.label || type;
    };
    //Need to watch all the variables or they are not updated
    scope.$watch("id", function (newVal, oldVal) {
      if (newVal) {
        scope.id = newVal
        setUrl(scope.type, scope.id)
      }
    }, true);
    scope.$watch("type", function (newVal, oldVal) {
      if (newVal) {
        scope.type = newVal
        setUrl(scope.type, scope.id)
      }
    }, true);
    scope.$watch("label", function (newVal, oldVal) {
      if (newVal) {
        scope.label = newVal
        setUrl(scope.type, scope.id)
      }
    }, true);

    scope.$watch("reference", function (newVal, oldVal) {
      if (!newVal) {

      } else if (typeof newVal === "object") {
        const type = newVal.entityType
        const id = newVal.entityId
        setUrl(type, id);
      } else if (typeof newVal === "string") {
        const split = newVal.split(":");
        const type = split[0]
        const id = split[1]
        setUrl(type, id);
      }
    }, true);

  }
})
